import { render, staticRenderFns } from "./component-items.vue?vue&type=template&id=d28c5fc4&scoped=true&"
import script from "./component-items.vue?vue&type=script&lang=js&"
export * from "./component-items.vue?vue&type=script&lang=js&"
import style0 from "./component-items.vue?vue&type=style&index=0&id=d28c5fc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28c5fc4",
  null
  
)

export default component.exports